exports.classicStyle = `
body { font-family:Helvetica,Arial,sans-serif; font-size:16px }
      `;
